export default __webpack_public_path__ + "static/media/president.971593fc.png";